"use client"

import { useState } from "react"
import { LogIn } from "lucide-react"
import { TurkwiseButton } from "@turkwise/design-system"
import { startAccountLinkRecovery, startAuth0Signup } from "@/lib/auth/client"
import { recoveryTarget } from "@/lib/auth/authFailure"

export function AccountLoginRecovery({ code, returnTo, onRetry }: { code: string; returnTo: string; onRetry: () => void }) {
  const [busy, setBusy] = useState(false)
  const target = recoveryTarget(code)
  const registration = code === "auth0_registration_required" && process.env.NEXT_PUBLIC_AUTH0_SELF_SIGNUP_ENABLED === "true"
  const inactive = code === "account_not_active"
  const continueRecovery = () => {
    if (busy) return
    setBusy(true)
    try {
      if (target && process.env.NEXT_PUBLIC_AUTH0_ACCOUNT_LINKING_ENABLED === "true") startAccountLinkRecovery(target)
      else if (registration) startAuth0Signup(returnTo, "login")
      else onRetry()
    } catch { setBusy(false) }
  }
  return <div className="space-y-4" data-testid="login-recovery">
    <h2 className="text-lg font-semibold text-[var(--twds-text)]">{inactive ? "Hesap erişimi kapalı" : registration ? "Hesabınızı hazırlayalım" : "Hesabınıza devam edelim"}</h2>
    <p role="status" className="text-sm leading-6 text-[var(--twds-text-subtle)]">{recoveryMessage(code)}</p>
    {!inactive && <TurkwiseButton type="button" variant="primary" size="base" className="twds-auth-form__primary-action" disabled={busy} loading={busy} onClick={continueRecovery} icon={<LogIn className="h-5 w-5" />}>
      {target ? "Mevcut hesabımı doğrula" : registration ? "Kaydı tamamla" : "Güvenli girişe devam et"}
    </TurkwiseButton>}
    <a href="/login" className="block text-center text-sm text-[var(--twds-text-subtle)] underline">Farklı bir hesapla giriş</a>
  </div>
}
function recoveryMessage(code: string) {
  if (code === "auth0_link_password_to_google") return "Mevcut hesabınızı doğruladıktan sonra oluşturduğunuz parolayı aynı hesaba bağlayacağız. Yeni parola oluşturmanız gerekmiyor."
  if (code === "auth0_link_google_to_password") return "Mevcut hesabınızı parolanızla doğruladıktan sonra Google girişini aynı hesaba bağlayacağız."
  if (code === "auth0_registration_required") return "Giriş doğrulandı. TurkWise kaydınızı tamamlayarak devam edebilirsiniz."
  if (code === "account_not_active") return "Bu hesabın erişimi için yöneticinizle görüşün."
  if (code === "auth0_email_not_verified") return "E-postanızdaki doğrulama bağlantısını açın, ardından girişe devam edin."
  if (code === "mfa_required") return "Hesabınızı açmak için güvenlik doğrulamasını tamamlayın."
  if (code === "external_identity_not_linked" || code === "auth0_existing_account_link_required") return "Daha önce kullandığınız giriş yöntemiyle hesabınızı doğrulayın."
  return "Giriş tamamlanamadı. Güvenli giriş ekranından yeniden deneyebilirsiniz."
}
